<template>
  <v-row no-gutters v-if="isStickyButtonsVisible" class="tw:gap-4">
    <v-col cols="auto" v-for="(button, idx) of stickyButtons" :key="idx">
      <base-button
        :type="button.cancel || button.cancelLike ? 'alternative' : undefined"
        :loading="isStickyButtonsLoading && !button.cancel"
        :disabled="(isStickyButtonsLoading && button.cancel) || (!isStickyButtonsValid && !button.cancel)"
        :tooltip="button.tooltip || null"
        @click="action(button.action, button.cancel)"
      >
        {{ $i18n.t(button.translationPath) }}
      </base-button>
    </v-col>
  </v-row>
</template>
<script>
import { get, sync } from 'vuex-pathify';

export default {
  name: 'MainDialogStickyButtons',
  computed: {
    stickyButtons: sync('sidebar/stickyButtonsModal'),
    isStickyButtonsLoading: get('sidebar/isStickyButtonsModalLoading'),
    isStickyButtonsValid: get('sidebar/isStickyButtonsModalValid'),
    isStickyButtonsVisible: sync('sidebar/isStickyButtonsModalVisible'),
  },
  methods: {
    action(action, cancel) {
      if (action) {
        this.$root.$emit(action);
      }
      if (cancel) {
        this.$emit('onClose');
      }
    },
  },
};
</script>
